
import { BoxManagementIndexPage } from './index.box';
import { CloudManagementIndexPage } from './index.cloud';
import { DemoManagementIndexPage } from './index.demo';

import { mixin } from '@cems-eco/core/src/utils/platform';
import environment from "@/config";

export default class ManagementIndex extends mixin(environment.nexus, {
    box: BoxManagementIndexPage,
    cloud: CloudManagementIndexPage,
    demo: DemoManagementIndexPage
}) { }
